import { getDefaultStatisticItem, getTeamLabelByNumber } from '../../utils/utils'

export default {
  statisticScheme: {
    'PT1': getDefaultStatisticItem('statistic.basketball.pt1'),
    'PT2': getDefaultStatisticItem('statistic.basketball.pt2'),
    'FOUL': getDefaultStatisticItem('statistic.foul')
  },
  statisticEvents: {
    'PT1': 'PT1',
    'PT2': 'PT2'
  },
  statisticFunction (event, relatedEvent) {
    const eventForProcess = event.EventCode === 'CANCEL' ? relatedEvent : event

    const { EventCode } = eventForProcess

    if (!['FOUL'].includes(EventCode)) return

    const {
      getCurrentPeriod
    } = this
    const { GamePeriod, TeamNumber } = eventForProcess

    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'FOUL',
      period: GamePeriod || getCurrentPeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: event.EventCode === 'CANCEL' ? 'decrement' : 'increment'
    })
  },
  statisticOrder: [
    'PT1',
    'PT2',
    'FOUL'
  ],
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}
